module.exports = __webpack_public_path__ + "static/scale-model-of-omaha-nebraska-c8ed2e4b3a0427b53e1e0a3d5473b6cb.png";